import normalizeValues from './normalizeValues';

// ----------------------------------------------------------------------------

function setValue(element: HTMLSelectElement, value: string | string[]): void {
    const values = normalizeValues(element, value);

    //
    if (element.multiple) {
        for (const elOption of element.options) {
            const match = values.includes(elOption.value);

            elOption.selected = match;
        }
    }
    //
    else {
        element.value = values[0] ?? '';
    }
}

// ----------------------------------------------------------------------------

export default setValue;
